export default __webpack_public_path__ + "f0f8230116992e521526097a28f54066.woff2";